/* Ficha especial del Pack Noche de Juegos — comportamiento de sections/tb-pack-pdp.liquid.
   Sin librerías. Sin JS la ficha funciona igual (el formulario es un POST normal). */
(function () {
  'use strict';
  function init(root) {
    root.classList.add('js');
    var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function $(s, c) { return (c || root).querySelector(s); }
    function $$(s, c) { return [].slice.call((c || root).querySelectorAll(s)); }

    /* ── Galería: carrusel con snap + miniaturas generadas desde las mismas fotos */
    var track = $('[data-gal-track]'), th = $('[data-gal-th]'), num = $('[data-gal-n]');
    if (track) {
      var slides = $$('.p5g-s', track), cur = 0;
      slides.forEach(function (s, i) {
        var im = s.querySelector('img'); if (!im) return;
        var b = document.createElement('button');
        b.type = 'button'; b.setAttribute('aria-label', 'Ver foto ' + (i + 1));
        var t = document.createElement('img'); t.src = im.currentSrc || im.src; t.alt = ''; t.loading = 'lazy';
        b.appendChild(t); th.appendChild(b);
        b.addEventListener('click', function () { goTo(i); });
      });
      var thumbs = $$('button', th);
      var goTo = function (i) {
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[i].offsetLeft, behavior: RM ? 'auto' : 'smooth' });
      };
      var mark = function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i === cur && num.textContent !== '1 / 1') return;
        cur = i; num.textContent = (i + 1) + ' / ' + slides.length;
        thumbs.forEach(function (b, k) {
          b.classList.toggle('on', k === i);
          if (k === i) { var l = b.offsetLeft - 20; if (th.scrollLeft > l || th.scrollLeft + th.clientWidth < b.offsetLeft + b.offsetWidth) th.scrollTo({ left: l, behavior: 'smooth' }); }
        });
      };
      track.addEventListener('scroll', function () { requestAnimationFrame(mark); }, { passive: true });
      $('[data-gal-prev]').addEventListener('click', function () { goTo(cur - 1); });
      $('[data-gal-next]').addEventListener('click', function () { goTo(cur + 1); });
      num.textContent = '1 / ' + slides.length; if (thumbs[0]) thumbs[0].classList.add('on');
    }

    /* ── Cantidad */
    var qin = $('[data-qty-in]');
    $$('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () { qin.value = Math.max(1, Math.min(20, (+qin.value || 1) + +b.getAttribute('data-qty'))); });
    });

    /* ── Agregar / comprar ahora: abre el carro del tema (no un sistema aparte) */
    var form = $('[data-p5-add]'), addBtn = form && form.querySelector('[type="submit"]');
    function badge(n) { document.querySelectorAll('.act-badge').forEach(function (b) { b.textContent = n; b.style.display = n > 0 ? '' : 'none'; }); }
    function add() {
      return fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'fetch', Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('add'); return fetch('/cart.js', { cache: 'no-store' }); })
        .then(function (r) { return r.json(); })
        .then(function (c) { badge(c.item_count); return c; });
    }
    function burst(btn) {
      if (RM || !btn) return;
      var r = btn.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      for (var i = 0; i < 14; i++) {
        var b = document.createElement('i'); b.className = 'c5-bit'; document.body.appendChild(b);
        var a = (i / 14) * Math.PI * 2, d = 60 + Math.random() * 50;
        b.style.left = (cx - 5) + 'px'; b.style.top = (cy - 5) + 'px';
        b.animate([{ transform: 'translate(0,0) rotate(0)', opacity: 1 }, { transform: 'translate(' + Math.cos(a) * d + 'px,' + (Math.sin(a) * d - 20) + 'px) rotate(' + (Math.random() * 360) + 'deg)', opacity: 0 }],
          { duration: 700 + Math.random() * 300, easing: 'cubic-bezier(.2,.8,.3,1)' }).onfinish = (function (x) { return function () { x.remove(); }; })(b);
      }
    }
    function openCart() {
      var link = document.querySelector('[data-cart-link][data-drawer-open]');
      if (link) link.click(); else window.location.href = '/cart';
    }
    function doAdd(btn) {
      if (!form) return;
      var b = btn || addBtn, sp = b.querySelector('span'), old = sp ? sp.textContent : '';
      b.classList.add('is-busy');
      add().then(function () {
        burst(b); b.classList.remove('is-busy'); b.classList.add('is-ok');
        if (sp) sp.textContent = 'Pack agregado ✓';
        setTimeout(function () { b.classList.remove('is-ok'); if (sp) sp.textContent = old; }, 1900);
        setTimeout(openCart, RM ? 0 : 450);
      }).catch(function () { b.classList.remove('is-busy'); HTMLFormElement.prototype.submit.call(form); });
    }
    /* En las fichas corre la app Condor Conversion Suite, que se queda con el evento `submit` de los
       formularios /cart/add (verificado: el clic llega, el submit nunca). Por eso el botón deja de
       ser submit apenas hay JS y agrega por su cuenta; sin JS sigue siendo un POST normal. */
    if (form) {
      if (addBtn) { addBtn.type = 'button'; addBtn.addEventListener('click', function () { doAdd(addBtn); }); }
      form.addEventListener('submit', function (e) { e.preventDefault(); doAdd(addBtn); });
    }
    $$('[data-p5-submit]').forEach(function (b) { b.addEventListener('click', function () { doAdd(b); }); });
    var now = $('[data-buy-now]');
    if (now) now.addEventListener('click', function () {
      now.classList.add('is-busy');
      add().then(function () {
        if (window.tbCheckoutPropio) window.tbCheckoutPropio(); else window.location.href = '/checkout';
      }).catch(function () { now.classList.remove('is-busy'); });
    });

    /* ── Barra fija: aparece cuando el botón principal sale de la pantalla */
    var bar = $('[data-p5-bar]');
    if (bar && form && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var show = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
        bar.classList.toggle('on', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        $$('button', bar).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
      }).observe(form);
    }

    /* ── Reloj del Cyber (solo si el evento no terminó) */
    var start = Date.parse(root.getAttribute('data-start')), end = Date.parse(root.getAttribute('data-end'));
    var clk = $('[data-p5-clk]'), cl = $('[data-p5-clk-l]'), ct = $('[data-p5-clk-t]'), live = $('[data-live-tx]');
    function p2(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      if (isNaN(start) || isNaN(end) || !clk) return false;
      var n = Date.now(), t;
      if (n >= end) { clk.hidden = true; if (live) live.textContent = 'Pack Noche de Juegos'; return false; }
      if (n < start) { cl.textContent = 'El Cyber empieza en'; t = start; if (live) live.textContent = 'Precio Cyber · desde el sábado 3 de octubre'; }
      else { cl.textContent = 'El Cyber termina en'; t = end; if (live) live.textContent = 'En vivo · precio Cyber hasta el jueves 15'; }
      t = Math.floor((t - n) / 1000);
      ct.textContent = Math.floor(t / 86400) + 'd ' + p2(Math.floor(t % 86400 / 3600)) + 'h ' + p2(Math.floor(t % 3600 / 60)) + 'm ' + p2(t % 60) + 's';
      clk.hidden = false; return true;
    }
    if (tick()) { var tid = setInterval(function () { if (!tick()) clearInterval(tid); }, 1000); }

    /* ── ¿Cuántos van a jugar? */
    var q = $('[data-p5-q]');
    if (q) {
      var qi = $('[data-q-in]', q), qo = $('[data-q-out]', q), say = $('[data-q-say]', q), gs = $$('[data-q-g]', q);
      var lo = +q.getAttribute('data-min'), hi = +q.getAttribute('data-max');
      var setN = function (n) {
        n = Math.max(lo, Math.min(hi, n)); qi.value = n;
        if (qo.textContent !== String(n)) { qo.textContent = n; if (!RM) { qo.classList.remove('pop'); void qo.offsetWidth; qo.classList.add('pop'); } }
        var ok = [];
        gs.forEach(function (g) {
          var on = n >= +g.getAttribute('data-min') && n <= +g.getAttribute('data-max');
          g.classList.toggle('on', on); g.classList.toggle('off', !on);
          if (on) ok.push(g.getAttribute('data-name'));
        });
        say.textContent = '';
        var pre = document.createTextNode('Con ' + n + ' personas ');
        say.appendChild(pre);
        if (ok.length === gs.length) { say.appendChild(document.createTextNode('pueden jugar ')); var b = document.createElement('b'); b.textContent = 'los ' + ok.length + ' juegos'; say.appendChild(b); say.appendChild(document.createTextNode('.')); }
        else if (ok.length) { say.appendChild(document.createTextNode('les sirve' + (ok.length > 1 ? 'n ' : ' '))); var b2 = document.createElement('b'); b2.textContent = ok.length > 1 ? ok.slice(0, -1).join(', ') + ' y ' + ok[ok.length - 1] : ok[0]; say.appendChild(b2); say.appendChild(document.createTextNode('.')); }
        else say.appendChild(document.createTextNode('ninguno de estos juegos calza.'));
      };
      qi.addEventListener('input', function () { setN(+qi.value); });
      $$('[data-q-step]', q).forEach(function (b) { b.addEventListener('click', function () { setN(+qi.value + +b.getAttribute('data-q-step')); }); });
      setN(+qi.value);
    }

    /* ── Guía rápida en grande */
    var dlg = $('[data-p5-dlg]'), dimg = $('[data-p5-dlg-img]');
    $$('[data-dlg-src]').forEach(function (b) {
      b.addEventListener('click', function () {
        dimg.src = b.getAttribute('data-dlg-src'); dimg.alt = b.getAttribute('data-dlg-alt') || '';
        if (dlg.showModal) dlg.showModal(); else window.open(dimg.src, '_blank');
      });
    });
    if (dlg) dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });

    /* ── Entradas al hacer scroll + la boleta que se imprime */
    var els = $$('.rv, .rcp');
    if ('IntersectionObserver' in window && !RM) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -10% 0px', threshold: .08 });
      els.forEach(function (el) { io.observe(el); });
    } else els.forEach(function (el) { el.classList.add('in'); });
  }
  function run() { document.querySelectorAll('[data-pk5]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
